<template>
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>上传</title>
    <desc>Created with Sketch.</desc>
    <g
      id="购物车"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="3-购物车-配件"
        transform="translate(-272.000000, -323.000000)"
        fill="currentColor"
        fill-rule="nonzero"
      >
        <g id="编组-2备份" transform="translate(270.000000, 319.000000)">
          <g id="编组-6备份" transform="translate(0.000000, 2.000000)">
            <path
              d="M6.0578125,7.10009795 L9.5,3.68603545 L9.5,12.971973 C9.5,13.2485355 9.7234375,13.471973 10,13.471973 C10.2765625,13.471973 10.5,13.2485355 10.5,12.971973 L10.5,3.71572295 L13.94375,7.10166045 C14.040625,7.19697295 14.1671875,7.24541045 14.29375,7.24541045 C14.4234375,7.24541045 14.553125,7.19541045 14.65,7.09541045 C14.84375,6.89853545 14.840625,6.58134795 14.64375,6.38759795 L10.3328125,2.14853545 C10.1375,1.95634795 9.825,1.95634795 9.6296875,2.15009795 L5.353125,6.38916045 C5.15625,6.58291045 5.15625,6.90009795 5.35,7.09697295 C5.5453125,7.29228545 5.8625,7.29384795 6.0578125,7.10009795 Z M17.5,10.237598 C17.2234375,10.237598 17,10.4610355 17,10.737598 L17,16.9954105 L3,16.9954105 L3,10.737598 C3,10.4610355 2.7765625,10.237598 2.5,10.237598 C2.2234375,10.237598 2,10.4610355 2,10.737598 L2,17.4954105 C2,17.771973 2.2234375,17.9954105 2.5,17.9954105 L17.5,17.9954105 C17.7765625,17.9954105 18,17.771973 18,17.4954105 L18,10.737598 C18,10.4610355 17.7765625,10.237598 17.5,10.237598 Z"
              id="上传"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Upload'
});
</script>
